import { RestResource } from "./common"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class EventContractProduct {
  externalId = ""
}

export const EVENT_CONTRACT_PRODUCT_DESER: SchemaDeSer<EventContractProduct> =
  new SchemaDeSerBuilder(EventContractProduct).ofString("externalId").toDeSer()

export class EventContractEvent {
  eventProductName = ""
  stopsTradingAt = ""
  settlementDate = ""
  symbol = ""
  eventProduct = new EventContractProduct()
}

export const EVENT_CONTRACT_EVENT_DESER: SchemaDeSer<EventContractEvent> =
  new SchemaDeSerBuilder(EventContractEvent)
    .ofString("eventProductName")
    .ofString("stopsTradingAt")
    .ofString("settlementDate")
    .ofString("symbol")
    .ofNested(
      "eventProduct",
      EVENT_CONTRACT_PRODUCT_DESER,
      EventContractProduct
    )
    .toDeSer()

export class EventContractInstrument extends RestResource {
  symbol = ""
  instrumentType = ""
  contractSide = ""
  strikePrice = ""
  event = new EventContractEvent()
}

export const EVENT_CONTRACT_INSTRUMENT_DESER: SchemaDeSer<EventContractInstrument> =
  new SchemaDeSerBuilder(EventContractInstrument)
    .ofString("symbol")
    .ofString("instrumentType")
    .ofString("contractSide")
    .ofString("strikePrice")
    .ofNested("event", EVENT_CONTRACT_EVENT_DESER, EventContractEvent)
    .toDeSer()
